import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import { toastr } from "react-redux-toastr";
import html2pdf from "html2pdf.js";
import label from "../../labels/interviewProcess_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
  getObjectiveStatusflag,
  getSubjectlistByExamId,
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import {
  getReservationData,
  saveQualificationMultiple,
  getAdminCategory,
  getAdminSubCategory,
  saveQualificationCutOff,
  getAllUnApproveCutOffListPagination,
  SeatMatrixLockUnlock,
  patchQualificationCutOff,
  getStageList,
  qualificationMultipleCheck
} from "../../actions/interviewProcessActions";
import {
  getObjectiveStatus,
  getReservedSeats,
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { CustomPdfDownload } from "../../../common/components/CustomPdfDownload";
import ApprovalRuleEntity from "../cutOff/ApprovalCutOffEntity";
import TablePagination from "../../../common/components/TablePagination";
import Select from "react-select";
import dayjs from "dayjs";
import {
  getYearList,
  getAdvertisementlistByYear,
  getPostCriteriaList,
} from "../../../common/actions/commonActions";

const QualifyingSeatMatrix = () => {
  const pdfRef = useRef(null);

  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });

  let {
    allReservationData,
    adminCategoriesList,
    adminSubCategoriesList,
    allUnapprovalCutOffList,
    unapprovalCutOffPageNoCounter,
    stageList
  } = useSelector((state) => state.interviewProcessReducer, shallowEqual);
  let tableCounter_unapproval = unapprovalCutOffPageNoCounter + 1;

  let { advertisementList, examList, reservedSeats,
    objectiveStatusDataFlag, } = useSelector(
      (state) => state.postExamProcessObjectReducer,
      shallowEqual
    );
  let { yearList, allYearList, postCriteria } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  let { objectiveStatusData } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  let unapprovalEntityHeader = [
    "No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Action",
  ];

  let rowPerPage = 10;
  const length = 50;
  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  let [selectedSubject, setSelectedSubject] = useState();
  let [selectedCategory, setSelectedCategory] = useState();
  let [selectedSubCategory, setSelectedSubCategory] = useState(null);
  let [selectedReservedSeat, setSelectedReservedSeat] = useState();
  let [isMultipleSave, setIsMultipleSave] = useState(false);
  let [requestedData, setRequestedData] = useState([]);
  const [stepName, setName] = useState("reserveseat");
  const [multipleVal, setMultipleVal] = useState(1);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(false);
  const [saveDataButtonFlag, setSaveDataButtonFlag] = useState(true);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [printFlag, setPrintFlag] = useState(true);
  const [qualifySeatMatrixData, setQualifySeatMatrixData] = useState([]);
  const [reservedSeatsTotal, setReservedSeatsTotal] = useState(0);
  const [selectedYear, setSelectedYear] = useState("");
  let [listCurrentPage, setListCurrentPage] = useState(0);
  let [options, setOption] = useState([]);
  let [selectedData, setSelectedData] = useState([]);
  const [flagArray, setFlagArray] = useState([]);
  const [flagArray1, setFlagArray1] = useState([]);
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  const [reservedSeatData, setReservedSeatData] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const dispatch = useDispatch();
  const [lockStatus, setLockStatus] = useState({
    flgSeatMatrixLocked: false,
    flgMultipleLocked: false,
  });
  const [seatSaved, setSeatSaved] = useState(false);
  const handleApprovalUser = (ele) => {
    setSelectedApprovalEntity(ele);
    setApprovalEntityModal(true);
  };
  const [selectedStage, setSelectedStage] = useState("");
  const [postCriteriaList, setPostCriteriaList] = useState([]);
  const [selectedPostCriteria, setSelectedPostCriteria] = useState([]);
  const [selectedSubjectType, setSelectedSubjectType] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [showMultiplePopup, setShowMultiplePopup] = useState(false);
  const [previousMultipleData, setPreviousMultipleData] = useState(null);
  const [multipleConfirmed, setMultipleConfirmed] = useState(false);
  // const postCriteriaIds = selectedPostCriteria.map(item => item.value);
  const postCriteriaIds = selectedPostCriteria.map(item => item.value);

  const downloadPdf = () => {
    let headData = [[label.Category, label.SubCategory, label.ReservedSeats]];

    let rowData = allReservationData.criteria.map((marksDt) => {
      return {
        barcodeNo: marksDt.category,
        rollNo: marksDt.subCategory,
        marks: marksDt.reservedSeats,
      };
    });
    let headdt = {
      exam_name: "Exam Name",
      subject_name: "Subject Name",
      STUDENT_COUNT: 100,
    };
    let exam_name = allReservationData.examName;
    let subject_name = allReservationData.subjectNmae;
    // CustomPdfDownload(rowData, headdt, subject_name, exam_name, headData);
    genPdf();
    setReloadItem(!reloadItem);
  };

  useEffect(() => {
    dispatch(getStageList());
  }, []);

  useEffect(() => {
    dispatch(getYearList());
    window.scrollTo(0, 0);
    onCancelButton();
    dispatch(getAdminCategory());
    dispatch(getAdminSubCategory());
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onCancelButton();
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepName]);

  useEffect(() => {
    if (stepName == "unapproved") {
      dispatch(
        getAllUnApproveCutOffListPagination(listCurrentPage, rowPerPage)
      );
    }
  }, [stepName, listCurrentPage, rowPerPage, dispatch]);

  useEffect(() => {
    setOption(null);
    let optVal = [];
    adminSubCategoriesList &&
      adminSubCategoriesList.length > 0 &&
      adminSubCategoriesList.map((element, index) =>
        optVal.push({ value: element.id, label: element.name })
      );
    setOption(optVal);
  }, [adminSubCategoriesList]);

  useEffect(() => {
    if (allReservationData?.postWiseCriteria?.length > 0) {
      setQualifySeatMatrixData(allReservationData.postWiseCriteria);
    } else if (allReservationData?.criteria?.length > 0) {
      setQualifySeatMatrixData([
        {
          postCriteriaId: 0,
          criteria: allReservationData.criteria,
          reservedMultiple: allReservationData.reservedMultiple,
        },
      ]);
    } else {
      setQualifySeatMatrixData([]);
    }
  }, [allReservationData]);

  useEffect(() => {
    setPrintFlag(qualifySeatMatrixData.length === 0);
    let resTotal = 0;
    qualifySeatMatrixData &&
      qualifySeatMatrixData.map((ele, indd) => {
        resTotal = resTotal + ele.reservedSeats;
      });
    setReservedSeatsTotal(resTotal);
  }, [qualifySeatMatrixData]);

  useEffect(() => {
    if (reservedSeats?.postWiseCriteria?.length > 0) {
      const allCriteria = reservedSeats.postWiseCriteria.flatMap(post => {
        const postInfo = postCriteria.find(
          p => p.id === post.postCriteriaId
        );

        return post.criteria.map(item => ({
          ...item,
          postCriteriaId: post.postCriteriaId,
          postName: postInfo?.name || ""
        }));
      });
      setReservedSeatData(allCriteria);
      setSelectedData(allCriteria);
    } else {
      setReservedSeatData([]);
      setSelectedData([]);
    }
  }, [reservedSeats]);

  useEffect(() => {
    if (reservedSeatData.length === 0) {
      setSelectedData([]);
      return;
    }

    // No post selected -> show all data
    if (selectedPostCriteria.length === 0) {
      setSelectedData(reservedSeatData);
      return;
    }

    const postId = selectedPostCriteria[0].value;

    const postData = reservedSeatData.filter(
      item => item.postCriteriaId === postId
    );

    setSelectedData(postData);

  }, [selectedPostCriteria, reservedSeatData]);

  useEffect(() => {
    if (stepName === "reserveseat") {
      setFlagArray([])
      if (objectiveStatusDataFlag && objectiveStatusDataFlag.length > 0) {
        const flagValues = objectiveStatusDataFlag.map((item) => item.flag);
        const flagArrayBeforeInterviewCriteria = [];

        // for (let i = 0; i < flagValues.length; i++) {
        //   if (flagValues[i] === "Seat Matrix") {
        //     setFlagArray(flagArrayBeforeInterviewCriteria);
        //     break;
        //   } else {
        //     flagArrayBeforeInterviewCriteria.push(objectiveStatusDataFlag[i]);

        //   }
        // }
        for (let i = 0; i < flagValues.length; i++) {
          if (flagValues[i] === "Seat Matrix") {
            setFlagArray(flagArrayBeforeInterviewCriteria);
            break;
          } else {
            // Hide Marks Criteria when flagStatus is false
            if (
              objectiveStatusDataFlag[i].flag === "Marks Criteria" &&
              objectiveStatusDataFlag[i].flagStatus === false
            ) {
              continue;
            }

            flagArrayBeforeInterviewCriteria.push(objectiveStatusDataFlag[i]);
          }
        }
        if (flagArrayBeforeInterviewCriteria.some(item => item.flagStatus === false)) {
          toastr.warning(label.UNLOCK_MESSAGE);
        }
      }
    } else if (stepName === "seatmatrix") {
      setFlagArray1(
        objectiveStatusDataFlag?.filter((item) => item?.flagStatus === true)
      );
    }
  }, [objectiveStatusDataFlag, stepName]);

  const postCriteriaOptions =
    postCriteria.map((item) => ({
      value: item.id,
      label: item.name,
    })) || [];

  const onAdvertisementChange = (ele) => {
    setSelectedAdvertNo(ele);
    setSelectedExam("");
    setSaveButtonFlag(false);
    setSaveDataButtonFlag(true);
    setConfirmClicked(false);
    setSelectedSubCategory("");
    setPrintFlag(true);
    setFlagArray1([]);
    setFlagArray([]);
    examList.length = 0;
    qualifySeatMatrixData.length = 0;
    reservedSeatData.length = 0;
    setIsMultipleSave(false);
    setMultipleVal("");
    ele && dispatch(getExamslistByAdvertisementId(ele));
    setReloadItem(!reloadItem);
  };

  useEffect(() => {
    setPrintFlag(qualifySeatMatrixData.length === 0);
    let resTotal = 0;
    qualifySeatMatrixData &&
      qualifySeatMatrixData.map((ele, indd) => {
        resTotal = resTotal + ele.reservedSeats;
      });
    setReservedSeatsTotal(resTotal);
  }, [qualifySeatMatrixData]);

  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton();
    } else {
      let selectedValue = ele;
      setSelectedYear(selectedValue);
      setSaveButtonFlag(false);
      selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
      if (allYearList) {
        allYearList.length = 0;
        setSaveDataButtonFlag(true);
        setSaveButtonFlag(false);
      }
      if (examList) {
        examList.length = 0;
        setSaveDataButtonFlag(true);
        setSaveButtonFlag(false);
      }
      setFlagArray1([]);
      setFlagArray([]);
      setSelectedSubCategory(null);
      reservedSeatData.length = 0;
      setReloadItem(!reloadItem);
    }
  };

  const onStageChange = (value) => {
    setSelectedStage(value);
    setMultipleVal("");
    setMultipleConfirmed(false);
    setShowMultiplePopup(false);
    setPreviousMultipleData(null);
    setSaveDataButtonFlag(true);
  };

  const onExamChange = (ele) => {
    setSelectedStage("");
    let selectedValue = ele;
    setSelectedExam(selectedValue);
    setLockStatus({
      flgSeatMatrixLocked: false,
      flgMultipleLocked: false,
    });
    setShowTable(false);
    setSeatSaved(false);
    Promise.resolve()
      .then(() => {
        if (ele !== "" && (stepName === "reserveseat" || stepName === "seatmatrix")) {
          return dispatch(getObjectiveStatusflag(selectedValue));
        }
        return Promise.resolve();
      })
      .then(() => {
        setSaveButtonFlag(true);
        setSaveDataButtonFlag(true);
        setConfirmClicked(true);
        setPrintFlag(true);
        return Promise.resolve();
      })
      .then(() => {
        setReloadItem((prev) => !prev);
        qualifySeatMatrixData.length = 0;
        reservedSeatData.length = 0;
        setMultipleVal("");
        setIsMultipleSave(false);
        return ele !== "" && dispatch(getObjectiveStatus(selectedValue));
      })
      .then(() => {
        return ele !== "" && dispatch(getReservedSeats(selectedValue));
      })
      .catch((error) => {
        console.error("Error during onExamChange:", error);
      });
  };

  useEffect(() => {
    if (objectiveStatusData) {
      setLockStatus({
        flgSeatMatrixLocked:
          objectiveStatusData?.flgSeatMatrixLocked === true,
        flgMultipleLocked:
          objectiveStatusData?.flgMultipleLocked === true,
      });
    }
  }, [objectiveStatusData]);

  useEffect(() => {
    if (selectedExam) {
      dispatch(getPostCriteriaList(selectedExam));
    }
  }, [selectedExam, dispatch]);

  const onCategoryChange = (val) => {
    if (val) {
      setSelectedCategory(val);
      setShowTable(true);
    }

    let newSelectData = [...selectedData];

    // let newSelectData2 = newSelectData.filter((item) => item.category === val);
    let newSelectData2 = newSelectData.filter(
      (item) =>
        item.category === val &&
        postCriteriaIds.includes(item.postCriteriaId)
    );

    if (newSelectData2.length > 0) {
      let subcats = [];
      newSelectData2.map((ele) => {
        let selCat =
          options && options.filter((itm) => itm.label == ele.subCategory);
        subcats.push(selCat[0]);
      });

      setSelectedSubCategory(subcats);
    } else {
      setSelectedSubCategory("");
    }

    setReloadItem(!reloadItem);
  };

  const onReservedSeatChange = (val, index) => {
    let tempData = [...selectedData];
    tempData[index].reservedSeats = val;
    setRequestedData(tempData);
    setSelectedData(tempData);
    setReloadItem(!reloadItem);
    setSaveDataButtonFlag(false);
  };

  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSelectedSubCategory("");
    setSaveDataButtonFlag(true);
    setSaveButtonFlag(false);
    setSelectedYear("");
    setConfirmClicked(false);
    setPrintFlag(true);
    setEditMode(false);
    setFlagArray1([]);
    setFlagArray([]);
    setSeatSaved(false);
    setQualifySeatMatrixData([]);
    // setSelectedPriority("");
    setSelectedReservedSeat("");
    setIsMultipleSave(false);
    // setSelectedCutOff("");
    setSelectedSubCategory(null);
    setSelectedData([]);
    allYearList.length = 0;
    examList.length = 0;
    qualifySeatMatrixData.length = 0;
    reservedSeatData.length = 0;
    setMultipleVal("");
    setReloadItem(!reloadItem);
    setSelectedStage("");
    setSelectedPostCriteria([]);
    setShowTable(false);
  };

  const updateSelectedData = (selectedSubCats, indexToRemove) => {
    let newSelectData = [...selectedData];
    // let newSelectData1 = newSelectData.filter(
    //   (item) => item.category !== selectedCategory
    // );
    // let newSelectData2 = newSelectData.filter(
    //   (item) => item.category === selectedCategory
    // );
    let newSelectData1 = newSelectData.filter(
      (item) =>
        !(
          item.category === selectedCategory &&
          postCriteriaIds.includes(item.postCriteriaId)
        )
    );
    let newSelectData2 = newSelectData.filter(
      (item) =>
        item.category === selectedCategory &&
        postCriteriaIds.includes(item.postCriteriaId)
    );

    newSelectData2 = newSelectData2.filter((item) =>
      selectedSubCats.some((subCat) => subCat.label === item.subCategory)
    );
    let mergedSelectData = [...newSelectData1, ...newSelectData2];
    selectedSubCats.forEach((ele1) => {
      // const existingItem = mergedSelectData.find(
      //   (item) => item.subCategory === ele1.label
      // );
      const existingItem = mergedSelectData.find(
        (item) =>
          item.postCriteriaId === selectedPostCriteria[0]?.value &&
          item.category === selectedCategory &&
          item.subCategory === ele1.label
      );

      if (!existingItem || existingItem.category !== selectedCategory) {
        // mergedSelectData.push({
        //   category: selectedCategory,
        //   subCategory: ele1.label,
        //   reservedSeats: ""
        // });
        mergedSelectData.push({
          postCriteriaId: selectedPostCriteria[0]?.value,
          postName: selectedPostCriteria[0]?.label,
          category: selectedCategory,
          subCategory: ele1.label,
          reservedSeats: ""
        });
      }
    });

    const subCatToRemove = selectedSubCats[indexToRemove]?.label;
    if (subCatToRemove !== undefined) {
      mergedSelectData = mergedSelectData.filter(
        ({ subCategory, category, postCriteriaId }) => {
          return !(
            subCategory === subCatToRemove &&
            category === selectedCategory &&
            postCriteriaIds.includes(postCriteriaId)
          );
        }
      );
    }

    mergedSelectData = mergedSelectData.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          (i) =>
            i.postCriteriaId === item.postCriteriaId &&
            i.category === item.category &&
            i.subCategory === item.subCategory
        )
    );
    setSelectedData(mergedSelectData);
    setReloadItem(!reloadItem);
  };

  const onSubmit = () => {
    if (stepName == "reserveseat") {
      let newData = requestedData;
      let newData1 = [];

      newData1 =
        newData &&
        newData.length > 0 &&
        newData.filter((ele) => ele.reservedSeats != "");
      if (newData1.length == 0) {
        toastr.error("Please fill atleast one Reserved seats fields.");
      } else {
        examList.length = 0;
        if (selectedYear !== "" && selectedAdvertNo !== "" && selectedCategory !== "" && selectedExam !== "" && selectedSubCategory !== "") {

          if (reservedSeats.criteria !== null && selectedData && selectedData.length > 0) {
            if (newData1 === false || newData1 === undefined || newData1 === null) {
              newData1 = selectedData;
            }
            if (objectiveStatusData?.flgSeatMatrixLocked) {
              toastr.error("Seat Matrix locked. Please unlock to edit");
              return;
            }
            newData1 &&
              dispatch(
                patchQualificationCutOff(
                  selectedExam,
                  postCriteriaIds,
                  newData1,
                  setRequestedData,
                  setSelectedData,
                  setSelectedSubCategory,
                  setSeatSaved(true)
                )
              );
          } else {
            selectedExam &&
              dispatch(
                saveQualificationCutOff(
                  selectedExam,
                  postCriteriaIds,
                  newData1,
                  setRequestedData,
                  setSelectedData,
                  setSelectedSubCategory,
                  setSeatSaved(true),
                )
              );
            setSeatSaved(true);
          }
        }
      }
      if (allYearList) {
        allYearList.length = 0;
      }
      if (examList) {
        examList.length = 0;
      }
      setSelectedData([]);
      setSelectedYear("");
      setSelectedSubCategory("");
      onCancelButton();
    }

    if (stepName === "seatmatrix" && selectedExam && selectedStage) {
      dispatch(getReservationData(selectedExam, selectedStage));
    }
    setReloadItem(!reloadItem);
    // onCancelButton();
  };

  const genPdf = () => {
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML =
      '<div class="row d-flex flex-column align-items-center"><h5 className="bold-label">' +
      label.MPSC +
      "</h5><h5>" +
      allReservationData.examName +
      "</h5><h5>" +
      label.QualifyingSeatMatrix +
      "</h5></div>";
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: "",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");
          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, textX, textY);

          const ad = allReservationData.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save("QualifyingSeatMatix.pdf");
      });
  };

  const handleMultipleVal = async (e) => {
    const val = e.target.value;
    setMultipleVal(val);
    setMultipleConfirmed(false);
    setShowMultiplePopup(false);
    setPreviousMultipleData(null);
    if (!val) {
      setSaveDataButtonFlag(true);
      return;
    }
    if (!selectedExam || !selectedStage) {
      setSaveDataButtonFlag(true);
      return;
    }
    setSaveButtonFlag(true);
    if (selectedStage.toUpperCase() === "PRE") {
      setSaveDataButtonFlag(false);
      return;
    }
    setSaveDataButtonFlag(true);
    try {
      const response = await dispatch(
        qualificationMultipleCheck(
          selectedExam,
          selectedStage,
          val
        )
      );
      if (
        response?.previousStage &&
        response?.previousMultiple != null
      ) {
        setPreviousMultipleData({
          previousStage: response.previousStage,
          previousMultiple: response.previousMultiple,
        });
        setShowMultiplePopup(true);
        return;
      }
      setSaveDataButtonFlag(false);

    } catch (error) {
      console.error(
        "Qualification Multiple Check Error:",
        error?.response?.data || error
      );
      setPreviousMultipleData(null);
      setShowMultiplePopup(false);
      setSaveDataButtonFlag(true);

      toastr.error("Unable to check previous stage multiple.");
    }
  };

  const saveMultipleSeatVal = () => {
    if (!multipleVal) {
      return;
    }

    if (
      selectedStage !== "PRE" &&
      !multipleConfirmed
    ) {
      toastr.warning("Please confirm the multiple first.");
      return;
    }

    setIsMultipleSave(true);
    setSaveDataButtonFlag(true);

    dispatch(
      saveQualificationMultiple(
        selectedExam,
        multipleVal,
        selectedStage,
        setSelectedAdvertNo,
        examList
      )
    );

    setSeatSaved(true);
  };
  const groupByCategory = () => {
    const groupedData = selectedData.reduce((acc, item) => {
      if (!acc[item.postCriteriaId]) {
        acc[item.postCriteriaId] = {
          postName: item.postName,
          rows: []
        };
      }

      acc[item.postCriteriaId].rows.push(item);

      return acc;
    }, {});
    qualifySeatMatrixData.forEach((item) => {
      const { category, subCategory, reservedSeats } = item;
      if (!groupedData[category]) {
        groupedData[category] = [];
      }
      groupedData[category].push({ subCategory, reservedSeats });
    });
    return groupedData;
  };

  const groupedCutOffData = groupByCategory();

  const handleLockUnlock = (status, lock) => {
    selectedExam &&
      dispatch(
        SeatMatrixLockUnlock(selectedExam, status, lock, getReservedSeats)
      );
    // onCancelButton();
  };

  const handleEditMode = (status) => {
    setEditMode(status);
    setSaveDataButtonFlag(false);
  };
  // const currentPostData = selectedData.filter(item =>
  //   postCriteriaIds.includes(item.postCriteriaId)
  // );
  const currentPostData =
    selectedPostCriteria.length > 0
      ? selectedData.filter(item =>
        postCriteriaIds.includes(item.postCriteriaId)
      )
      : selectedData;
  return (
    <div className="dashboardContentArea">
      <h5 className="labelMargin"> {label.QualifyingSeatMatrix} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" key="0">
            <a
              href="#"
              className={
                stepName === "reserveseat"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="reserveseat"
              id="reserveseat-tab"
              onClick={() => setName("reserveseat")}
              data-toggle="tab"
              role="tab"
              aria-controls="reserveseat"
              aria-selected="false"
            >
              <span>{label.reservedSeat}</span>
            </a>
          </li>
          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "unapproved"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="unapproved"
              id="unapproved-tab"
              onClick={() => setName("unapproved")}
              data-toggle="tab"
              role="tab"
              aria-controls="unapproved"
              aria-selected="false"
            >
              <span>{label.unreservedSeatList}</span>
            </a>
          </li>
          <li className="nav-item" key="2">
            <a
              href="#"
              className={
                stepName === "seatmatrix"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="seatmatrix"
              id="seatmatrix-tab"
              onClick={() => setName("seatmatrix")}
              data-toggle="tab"
              role="tab"
              aria-controls="seatmatrix"
              aria-selected="false"
            >
              <span>{label.SeatMatrix}</span>
            </a>
          </li>
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "reserveseat"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="reserveseat"
            role="tabpanel"
            aria-labelledby="reserveseat-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear"
                          // ref={register({ required: true })}
                          value={selectedYear}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList.map((element, index) => (
                              <option>{element}</option>
                            ))}
                        </select>
                        {_.get("selectedYear.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-4">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo"
                          // ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {allYearList &&
                            allYearList.length > 0 &&
                            allYearList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam1"
                          // ref={register({ required: true })}
                          onChange={(e) => {
                            e.target.value !== '' && onExamChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted === false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          Post Selection
                          <span className="errorText">*</span>
                        </label>

                        <Select
                          isMulti
                          closeMenuOnSelect={false}
                          options={postCriteriaOptions}
                          value={selectedPostCriteria}
                          onChange={(selected) => {
                            setSelectedPostCriteria(selected);

                            // Reset previous selection
                            setSelectedCategory("");
                            setSelectedSubCategory(null);
                            // setSelectedData([]);
                            // setRequestedData([]);
                            setShowTable(false);

                            setEditMode(true);
                          }}
                        />
                      </div>
                      {(editMode ||
                        (selectedExam && selectedPostCriteria.length > 0)) && (
                          <>
                            <div className="form-group col-md-3">
                              <label className="float-left">
                                {label.SelectCategory}
                                <span className="errorText">*</span>
                              </label>
                              <select
                                className="form-control"
                                name="selectedCategory1"
                                // ref={register({ required: true })}
                                value={selectedCategory || ""}
                                onChange={(e) => {
                                  onCategoryChange(e.target.value);
                                }}
                              >
                                <option key={0} value="">
                                  {commonLabels.COMBO_SELECT}
                                </option>
                                {adminCategoriesList &&
                                  adminCategoriesList.length > 0 &&
                                  adminCategoriesList.map((element, index) => (
                                    <option key={index} value={element.name}>
                                      {element.name}
                                    </option>
                                  ))}
                              </select>
                            </div>
                            <div className="col-md-3">
                              <label className="float-left">
                                {label.SelectSubCategory}
                                <span className="errorText">*</span>
                              </label>
                              <Select
                                closeMenuOnSelect={false}
                                isMulti
                                name="selectedSubCategory1"
                                // ref={register({ required: true })}
                                value={selectedSubCategory}
                                onChange={(e) => {
                                  setSelectedSubCategory(e);
                                  updateSelectedData(e);
                                  setEditMode(true);
                                }}
                                options={options && options}
                              />
                            </div>
                          </>
                        )}
                    </div>
                    <div className="row pl-3 pr-3">
                      {flagArray &&
                        flagArray
                          .filter(
                            (ele) =>
                              ![
                                "Absentee",
                                "Duplicate",
                                "Out Of Range",
                                "Version Mismatch",
                                "Marks",
                              ].includes(ele.flag)
                          )
                          .map((ele, index) => (
                            <div className="d-flex p-2" key={index}>
                              <input
                                type="checkbox"
                                disabled
                                checked={ele.flagStatus === true}
                                className="form-control"
                              />
                              <label className="ml-1">{ele.flag}</label>
                            </div>
                          ))}
                    </div>
                    <div className="row mt-2">
                      <div className="form-group col-md-6">
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>
                        {(editMode ||
                          (reservedSeats.criteria === null &&
                            selectedExam)) &&
                          <button
                            type="button"
                            disabled={saveDataButtonFlag}
                            className="btn btn-primary mr-2"
                            onClick={(e) => {
                              onSubmit(e);
                            }}
                          >
                            {commonLabels.BUTTON_SAVE}
                          </button>}

                        {(reservedSeatData && reservedSeatData.length > 0 && !editMode) &&
                          <button
                            type="button"
                            className="btn btn-primary mr-2"
                            disabled={(!selectedExam || (objectiveStatusData.flgSeatMatrixLocked !== null && objectiveStatusData.flgSeatMatrixLocked !== true && objectiveStatusData.flgSeatMatrixLocked !== false))}
                            onClick={() => {
                              handleEditMode(true);
                            }}>
                            {commonLabels.BUTTON_EDIT}
                          </button>
                        }
                        {(reservedSeatData && reservedSeatData.length > 0 && !editMode) &&
                          <button
                            type="button"
                            className="btn btn-primary mr-2"
                            onClick={() => {
                              setShowTable(true);
                            }}
                          >
                            {commonLabels.BUTTON_VIEW}
                          </button>
                        }

                        {(session.roleName == "superadmin" ||
                          session.roleName == "secretary") && (
                            <button
                              type="button"
                              className={`btn mr-2 ${lockStatus.flgSeatMatrixLocked
                                ? "btn-lock-green"
                                : "btn-unlock-red"
                                }`}
                              style={{
                                borderRadius: "0.60rem",
                              }}
                              disabled={!selectedExam || saveDataButtonFlag === false}
                              onClick={() => {
                                handleLockUnlock(
                                  "seatmatrix",
                                  !lockStatus.flgSeatMatrixLocked
                                );
                              }}
                            >
                              {lockStatus.flgSeatMatrixLocked
                                ? commonLabels.BUTTON_UNLOCK
                                : commonLabels.BUTTON_LOCK}
                            </button>
                          )}
                      </div>
                    </div>

                    {showTable && currentPostData.length > 0 && (
                      <>
                        {Object.entries(
                          currentPostData.reduce((acc, item) => {
                            if (!acc[item.postCriteriaId]) {
                              acc[item.postCriteriaId] = [];
                            }
                            acc[item.postCriteriaId].push(item);
                            return acc;
                          }, {})
                        ).map(([postId, rows]) => (
                          <div className="row mt-5 mb-2" key={postId}>
                            <div className="form-group col-md-12">

                              {showTable && !editMode && (
                                <h5>
                                  <strong>
                                    Post :{" "}
                                    {postCriteria.find(
                                      p => p.id === Number(postId)
                                    )?.name}
                                  </strong>
                                </h5>
                              )}

                              <table className="table table-bordered text-center">
                                <thead className="thead-light">
                                  <tr>
                                    <th>{label.category}</th>
                                    <th>{label.subCategory}</th>
                                    <th>{label.reservedSeat}</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {rows.map((ele) => {
                                    const originalIndex = selectedData.findIndex(
                                      item =>
                                        item.postCriteriaId === ele.postCriteriaId &&
                                        item.category === ele.category &&
                                        item.subCategory === ele.subCategory
                                    );

                                    return (
                                      <tr
                                        key={`${ele.postCriteriaId}-${ele.category}-${ele.subCategory}`}
                                      >
                                        <td>
                                          <strong>{ele.category}</strong>
                                        </td>

                                        <td>
                                          <strong>{ele.subCategory}</strong>
                                        </td>

                                        <td>
                                          {editMode ? (
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={ele.reservedSeats}
                                              onChange={(e) =>
                                                onReservedSeatChange(
                                                  e.target.value,
                                                  originalIndex
                                                )
                                              }
                                            />
                                          ) : (
                                            ele.reservedSeats
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>

                            </div>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "unapproved"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="unapproved"
            role="tabpanel"
            aria-labelledby="unapproved-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                {allUnapprovalCutOffList &&
                  allUnapprovalCutOffList.entityApprovalDtoList &&
                  allUnapprovalCutOffList.entityApprovalDtoList.length > 0 ? (
                  <>
                    <table className="table table-bordered">
                      <thead className="thead-light">
                        <tr>
                          {unapprovalEntityHeader &&
                            unapprovalEntityHeader.map((itm, ind) => (
                              <th
                                key={ind}
                                className={`${itm === "No." || itm === "Action"
                                  ? "text-center"
                                  : ""
                                  }`}
                              >
                                {itm}
                              </th>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {allUnapprovalCutOffList &&
                          allUnapprovalCutOffList.entityApprovalDtoList &&
                          allUnapprovalCutOffList.entityApprovalDtoList.length >
                          0 &&
                          allUnapprovalCutOffList.entityApprovalDtoList.map(
                            (ele, index) => {
                              return (
                                <tr key={index}>
                                  <td className="w-5 text-center">
                                    {tableCounter_unapproval++}
                                  </td>
                                  <td className=" word-break">
                                    {ele.entityApprovalAction.actionLabel}
                                  </td>
                                  <td className=" width-5">
                                    {ele.entityApprovalAction.level == 1
                                      ? label.APPROVAL_LEVEL_1_PENDING
                                      : ""}
                                    {ele.entityApprovalAction.level == 2
                                      ? label.APPROVAL_LEVEL_2_PENDING
                                      : ""}
                                    {ele.entityApprovalAction.level == 3
                                      ? label.APPROVAL_LEVEL_3_PENDING
                                      : ""}
                                  </td>
                                  <td className=" word-break width-10">
                                    {ele.entityApprovalAction.updatedAt
                                      ? dayjs(
                                        ele.entityApprovalAction.updatedAt
                                      ).format("DD/MM/YYYY h:mm A")
                                      : ""}
                                  </td>

                                  <td className="w-10 word-break text-center width-20">
                                    {(() => {
                                      const detail =
                                        typeof ele.entityApprovalAction.entityApprovalDto.detail === "string"
                                          ? JSON.parse(ele.entityApprovalAction.entityApprovalDto.detail)
                                          : ele.entityApprovalAction.entityApprovalDto.detail;

                                      const displayData = detail?.displayData || detail;

                                      return (
                                        <>
                                          {displayData?.exam?.name}
                                          <br />
                                          {/* {displayData?.exam?.nameDvng} */}
                                        </>
                                      );
                                    })()}
                                  </td>

                                  <td>
                                    {ele.entityApprovalAction.entityApprovalDto.entityMaster.name.replace(
                                      "_",
                                      " "
                                    )}
                                  </td>

                                  <td className=" word-break">
                                    {
                                      ele.entityApprovalAction.entityApprovalDto
                                        .approvalTypeLabel
                                    }
                                  </td>
                                  <td className=" word-break">
                                    {
                                      ele.entityApprovalAction.entityApprovalDto
                                        .approvalByUser.firstName
                                    }{" "}
                                    {
                                      ele.entityApprovalAction.entityApprovalDto
                                        .approvalByUser.lastName
                                    }
                                  </td>

                                  <td className=" word-break">
                                    {ele.entityApprovalAction.comments}
                                  </td>
                                  <td className="text-center word-break width-12">
                                    {(session.roleName == "superadmin" ||
                                      session.roleName == "desk officer") && (
                                        <button
                                          type="button"
                                          className="pull-right btn btn-outline-primary btn-sm custom-button"
                                          onClick={() => {
                                            handleApprovalUser(ele);
                                          }}
                                        >
                                          {commonLabels.REVIEW}
                                        </button>
                                      )}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                      </tbody>
                    </table>
                    <TablePagination
                      paginationFor="un_cutoff_list"
                      rowPerPage={rowPerPage}
                      setListCurrentPage={setListCurrentPage}
                      totalCount={allUnapprovalCutOffList.totalNoOfRecords}
                    />
                  </>
                ) : (
                  <div className="text-center">
                    <font className="text-danger">
                      {commonLabels.NO_DATA_FOUND}
                    </font>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "seatmatrix"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="seatmatrix"
            role="tabpanel"
            aria-labelledby="seatmatrix-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear1"
                          value={selectedYear}
                          // ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList.map((element, index) => (
                              <option>{element}</option>
                            ))}
                        </select>
                        {_.get("selectedYear1.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-4">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo1"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {allYearList &&
                            allYearList.length > 0 &&
                            allYearList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo1.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>

                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam"
                          // ref={register({ required: true })}
                          onChange={(e) => {
                            onExamChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {commonLabels.SelectStage}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control" name
                          name="selectedStage"
                          value={selectedStage}
                          onChange={(e) =>
                            onStageChange(e.target.value.toUpperCase())
                          }                        >
                          <option value="">
                            {commonLabels.COMBO_SELECT}
                          </option>

                          {stageList &&
                            stageList.length > 0 &&
                            stageList.map((element, index) => (
                              <option
                                key={index}
                                value={element.label?.toUpperCase()}
                              >
                                {element.label?.toUpperCase()}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.MultipleLabel}
                          <span className="errorText">*</span>
                        </label>
                        {isMultipleSave == true ? (
                          <input
                            type="text"
                            pattern="^[0-9]*$"
                            className="form-control"
                            ref={register({ required: true })}
                            min={0.5}
                            max={99.5}
                            maxLength="3"
                            step={0.5}
                            disabled="disabled"
                            readonly
                            name="mutlipleVal"
                            onKeyPress={(e) => {
                              const isDigit = /^\d$/.test(e.key);
                              const isSpace = e.key === " ";

                              if (
                                !(isDigit || (e.target.value === "" && isSpace))
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        ) : (
                          <input
                            type="text"
                            pattern="^[0-9]*$"
                            className="form-control"
                            min={0.5}
                            max={99.5}
                            maxLength="3"
                            step={0.5}
                            onChange={(e) => handleMultipleVal(e)}
                            value={multipleVal}
                            name="mutlipleVal"
                            onKeyPress={(e) => {
                              const isDigit = /^\d$/.test(e.key);
                              const isSpace = e.key === " ";

                              if (
                                !(isDigit || (e.target.value === "" && isSpace))
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        )}

                        {_.get("mutlipleVal.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="row pl-3 pr-3">
                        {flagArray1 &&
                          flagArray1
                            .filter((ele) => ele.flagStatus === true)
                            .map((ele, index) => (
                              <div className="d-flex p-2" key={index}>
                                <input
                                  type="checkbox"
                                  disabled
                                  checked
                                  className="form-control"
                                />
                                <label className="ml-1">{ele.flag}</label>
                              </div>
                            ))}
                      </div>
                      <div className="form-group col-md-12">
                        {(session.roleName == "superadmin" ||
                          session.roleName == "secretary" ||
                          session.roleName == "desk officer") && (
                            <>
                              {" "}
                              <button
                                type="reset"
                                className="btn btn-secondary mr-2"
                                onClick={() => onCancelButton()}
                              >
                                {commonLabels.BUTTON_CANCEL}
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                disabled={saveDataButtonFlag}
                                onClick={() => {
                                  saveMultipleSeatVal();
                                }}
                              >
                                {commonLabels.BUTTON_SAVE}
                              </button>

                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                disabled={!saveButtonFlag}
                                onClick={(e) => {
                                  onSubmit(e);
                                  setConfirmClicked(true);
                                }}
                              >
                                {commonLabels.BUTTON_VIEW}
                              </button>
                            </>
                          )}
                        {(session.roleName == "superadmin" ||
                          session.roleName == "secretary") && (
                            <button
                              type="button"
                              className="btn btn-primary mr-2"
                              disabled={printFlag || !confirmClicked}
                              onClick={() => {
                                genPdf();
                              }}
                            >
                              {commonLabels.BUTTON_PRINT}
                            </button>
                          )}
                        {(session.roleName == "superadmin" ||
                          session.roleName == "secretary") && (
                            <button
                              type="button"
                              className={`btn mr-2 ${lockStatus.flgMultipleLocked
                                ? "btn-lock-green"
                                : "btn-unlock-red"
                                }`}
                              style={{
                                borderRadius: "0.60rem",
                              }}
                              disabled={!selectedExam || (!lockStatus.flgMultipleLocked && !seatSaved)}
                              onClick={() => {
                                handleLockUnlock(
                                  "multiple",
                                  !lockStatus.flgMultipleLocked
                                );
                              }}
                            >
                              {lockStatus.flgMultipleLocked
                                ? commonLabels.BUTTON_UNLOCK
                                : commonLabels.BUTTON_LOCK}
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div ref={pdfRef}>
              {qualifySeatMatrixData
                ?.filter(post => post.criteria && post.criteria.length > 0)
                .map((post, index) => {
                  if (!post.criteria || post.criteria.length === 0) {
                    return null;
                  }
                  const groupedData = post.criteria.reduce((acc, item) => {
                    if (!acc[item.category]) {
                      acc[item.category] = [];
                    }
                    acc[item.category].push(item);
                    return acc;
                  }, {});

                  const reservedSeatsTotal = post.criteria.reduce(
                    (sum, item) => sum + item.reservedSeats,
                    0
                  );

                  return (

                    <div
                      key={post.postCriteriaId || index}
                      className="answerKeyTable"
                      id="cutOff"
                    >
                      <h6 className="mb-2">
                        <strong>
                          Post :
                          {
                            postCriteria.find(
                              p => p.id === post.postCriteriaId
                            )?.name || post.postCriteriaId
                          }
                        </strong>
                      </h6>
                      <table className="table table-bordered text-center">
                        <thead className="thead-light bold-label">
                          <tr>
                            <th>{label.Category}</th>
                            <th>{label.SubCategory}</th>
                            <th>{label.reservedSeat}</th>
                            <th>{label.MultipleLabel}</th>
                            <th>{label.totalSeats}</th>
                          </tr>
                        </thead>

                        <tbody>
                          {Object.entries(groupedData).map(([category, data], idx) => (
                            <React.Fragment key={idx}>
                              <tr>
                                <td
                                  className="text-center align-middle"
                                  rowSpan={data.length}
                                >
                                  {category}
                                </td>

                                <td>{data[0].subCategory}</td>

                                <td>{data[0].reservedSeats}</td>

                                <td>
                                  {post.reservedMultiple
                                    ? `X ${post.reservedMultiple}`
                                    : ""}
                                </td>

                                <td>
                                  {post.reservedMultiple
                                    ? data[0].reservedSeats * post.reservedMultiple
                                    : data[0].reservedSeats}
                                </td>
                              </tr>

                              {data.slice(1).map((item, subIndex) => (
                                <tr key={subIndex}>
                                  <td>{item.subCategory}</td>

                                  <td>{item.reservedSeats}</td>

                                  <td>
                                    {post.reservedMultiple
                                      ? `X ${post.reservedMultiple}`
                                      : ""}
                                  </td>

                                  <td>
                                    {post.reservedMultiple
                                      ? item.reservedSeats * post.reservedMultiple
                                      : item.reservedSeats}
                                  </td>
                                </tr>
                              ))}
                            </React.Fragment>
                          ))}

                          <tr>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>

                            <td>
                              <strong>
                                {label.totalSeats} = {reservedSeatsTotal}
                              </strong>
                            </td>

                            <td>&nbsp;</td>

                            <td>
                              <strong>
                                {label.totalSeats} ={" "}
                                {reservedSeatsTotal *
                                  (post.reservedMultiple || 1)}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>

      {approvalEntityModal && (
        <ApprovalRuleEntity
          showModal={approvalEntityModal}
          setShowModal={setApprovalEntityModal}
          setSelectedApprovalEntity={selectedApprovalEntity}
        />
      )}

      {showMultiplePopup && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header bg-light">
                <h4 className="modal-title ">
                  Confirmation
                </h4>
              </div>

              <div className="modal-body">
                <p>
                  Multiple for{" "}
                  <strong>{previousMultipleData?.previousStage}</strong> is{" "}
                  <strong>{previousMultipleData?.previousMultiple}</strong>.
                  {" "}Are you sure you want to add Multiple{" "}
                  <strong>{multipleVal}</strong> for{" "}
                  <strong>{selectedStage}</strong> ?
                </p>
              </div>
              <div className="modal-footer bg-light">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowMultiplePopup(false);
                    setPreviousMultipleData(null);
                    setMultipleConfirmed(false);

                    setMultipleVal("");
                    setSaveDataButtonFlag(true);
                  }}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    setShowMultiplePopup(false);
                    setMultipleConfirmed(true);
                    setSaveDataButtonFlag(false);
                  }}
                >
                  Yes
                </button>

              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QualifyingSeatMatrix;
